var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.componentClass, style: _vm.componentStyle }, [
    _c("iframe", {
      staticClass: "aspect-ratio-object",
      attrs: {
        allow: _vm.allowedOptionsList,
        allowfullscreen: _vm.allowFullScreen,
        src: [
          _vm.isYouTubeCookieAllowed
            ? `https://www.youtube.com/embed/${_vm.videoId}`
            : `https://www.youtube-nocookie.com/embed/${_vm.videoId}`,
        ],
        title: _vm.title,
        frameborder: "0",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }